import React from "react";
import { Link } from "react-router-dom";
import { Button, LinkedInButton } from "components/generic/kit";
import { Input, Formik } from "components/generic/form/formik";
import { Title, Row, Label, ErrorBox } from "components/generic/form/service";
import { NarrowBody } from "components/generic/layout";
import { SignInLayout } from "components/common/auth";

export default ({
  validationSchema,
  onSubmit,
  onSignInSuccess,
  linkedInSignInApi,
  signInApi,
  errors
}) => (
  <SignInLayout>
    <NarrowBody>
      <Formik
        initialValues={{
          email: "",
          password: ""
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        errors={errors.field}
      >
        {props => (
          <div>
            {!!errors.nonField.length && <ErrorBox errors={errors.nonField} />}
            <Title>Welcome back!</Title>
            <form onSubmit={props.handleSubmit}>
              <Row>
                <Label title="Email">
                  <Input name="email" type="email" placeholder="Your email" />
                </Label>
              </Row>
              <Row>
                <Label title="Password">
                  <Input
                    name="password"
                    type="password"
                    placeholder="Your password"
                  />
                </Label>
              </Row>

              <div className="mt3 flex items-center">
                <Button
                  type="submit"
                  color="white"
                  disabled={signInApi.isFetching}
                >
                  Log In
                </Button>
                <div className="ml3">
                  <LinkedInButton
                    onClick={() => window.IN.User.authorize(onSignInSuccess)}
                    disabled={linkedInSignInApi.isFetching}
                  >
                    Sign in with LinkedIn
                  </LinkedInButton>
                </div>
                <div className="ml-auto">
                  <Link
                    to="/auth/forgot-password"
                    className="link dim dark-blue fw6 underline"
                  >
                    Forgot Password ?
                  </Link>
                </div>
              </div>
            </form>
          </div>
        )}
      </Formik>
      <a href="https://www.thelobby.io" className="link mt2 dib brand">
        ← Back to the Homepage
      </a>
    </NarrowBody>
  </SignInLayout>
);



// WEBPACK FOOTER //
// ./src/components/pages/Auth/Login/View.js